<template>
  <div id="page-connection-create">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab label="Cadastro" icon-pack="feather" icon="icon-link-2">
            <div class="tab-text">
              <connection-form class="mt-4" :data="company" @createConnection="(data) => { this.createConnection(data) }"/>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ConnectionForm from './ConnectionForm.vue'
export default {
  components: { ConnectionForm },
  data () {
    return {
      company: {
        name: null,
        email: null,
        phone: null,
        type: { id: 2, label: 'Fornecedor' },
        logisticInfo: { id: 2, label: 'Entrega' },
        logisticOperatorConnection: null,
        checklistConnection: {},
        couldCreateLot: true,
        couldCreateProcess: true,
        couldReverseLogistic: true,
        logisticOperators: [],
        checklists: []
      }
    } 
  },
  methods: {
    apiErrorMsg (msg) {
      if (msg === 'users.phone') { return 'Celular inválido ou já cadastrado' }
      if (msg === 'phone') { return 'Celular de pelo menos um usuário deve ser indormado' }
      if (msg === 'name') { return 'O nome da conta deve ser especificado' }
      if (msg === 'email') { return 'O email da conta deve ser especificado' }
      if (msg === 'users.email') { return 'O email já esta sendo utilizado por outro usuário' }
    },
    async createConnection (data) {
      try {
        this.$vs.loading()
        await this.$http.post(
          '/api/v1/admin/company/connections',
          {
            name: data.name,
            email: data.email,
            phone: data.phone,
            logisticInfo: data.logisticInfo.label,
            type: data.type.label,
            logisticOperatorConnection: data.logisticOperatorConnection ? data.logisticOperatorConnection.id : null,
            checklistConnection: data.checklistConnection ? data.checklistConnection.id : null,
            couldCreateLot: data.couldCreateLot,
            couldCreateProcess: data.couldCreateProcess,
            couldReverseLogistic: data.couldReverseLogistic
          },
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.$vs.notify({
          title: 'Conexão criada',
          text: 'Criação feita com sucesso',
          iconPack: 'feather',
          color: 'success'
        })
      } catch (error) {
        this.$vs.notify({
          title: 'Erro na Criação',
          text: this.apiErrorMsg(error.response.data.errors[0].path),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    async getLogisticOperators () {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get(
          '/api/v1/admin/company/connections',
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.company.logisticOperators = data.filter(e => e.type === 'Operador logístico').map(e => { return { id: e.id, label: e.name } })
        this.company.logisticOperatorConnection = this.company.logisticOperators[0]
      } catch (e) {
        console.log(e)
      } finally { this.$vs.loading.close() }
    },
    async getChecklists () {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get(
          '/api/v1/admin/company/checklists',
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.company.checklists = data.map(e => { return { id: e.id, label: e.name } })
        this.company.checklistConnection = this.company.checklists[0]
      } catch (e) {
        console.log(e)
      } finally { this.$vs.loading.close() }
    }
  },
  mounted () {
    this.getChecklists()
    this.getLogisticOperators()
  }
}
</script>
